import { render, staticRenderFns } from "./ValSummary.vue?vue&type=template&id=7b35f2c3&"
import script from "./ValSummary.vue?vue&type=script&lang=ts&"
export * from "./ValSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports